module.exports = __webpack_public_path__ + "static/media/MdotMain.33e50826.png";